
define('template!ordersDetailMessagesFooterView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="message-ctn">\n  <div class="message-region"></div> \n  <div class="buttons">\n    <div class="send-button-region"></div>\n    <div class="attachment-button-region"></div>\n  </div>\n  <div class="action-required">  \n      <div class="action-required-internal-region"></div>\n      <div class="action-required-ukr-region"></div>\n  </div>\n</div>\n\n<div class="attachments-region"></div>\n\n<input class="attachment-input" multiple type="file" name="filename" accept="*" style="display:none;"/>';

}
return __p
};});

